export default __webpack_public_path__ + "static/media/A053AE46-EEEA-4FC0-B9E8-17A7CA65A616_1_105_c.e6486668.jpeg";